module.exports = __webpack_public_path__ + "img/Осенние берёзы. х-м 95х90. 2003г. 900$.b28315b1.jpg";